var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#587E85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2002 12.9999V10.5999C17.2002 9.9375 17.7378 9.3999 18.4002 9.3999H19.6002V6.3999H17.2002C15.2118 6.3999 13.6002 8.0115 13.6002 9.9999V12.9999H11.2002V15.9999H13.6002V25.5999H17.2002V15.9999H19.6002L20.8002 12.9999H17.2002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFacebook);
export default __webpack_public_path__ + "static/media/new_facebook.ca156a8be8d78e553f941bb1bdd939ee.svg";
export { ForwardRef as ReactComponent };